var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSandNuevo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A0ADC0;stroke:#A0ADC0;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.3,149.8H31.7v-113h136.7V149.8z M36.8,144.7h126.5V41.9H36.8V144.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100,149.8c-0.5,0-0.9-0.1-1.3-0.4l-65.8-39.8c-1-0.6-1.4-1.8-1.1-2.9c0.3-1.1,1.3-1.9,2.5-1.9h131.6 c1.1,0,2.2,0.8,2.5,1.9c0.3,1.1-0.2,2.3-1.1,2.9l-65.8,39.8C100.9,149.7,100.5,149.8,100,149.8z M43.4,110l56.6,34.3l56.6-34.3 H43.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.8,148.1c-1.4,0-2.6-1.1-2.6-2.6v-20.2c0-1.4,1.1-2.6,2.6-2.6c1.4,0,2.6,1.1,2.6,2.6v20.2 C66.4,147,65.2,148.1,63.8,148.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137,148.1c-1.4,0-2.6-1.1-2.6-2.6v-20.1c0-1.4,1.1-2.6,2.6-2.6c1.4,0,2.6,1.1,2.6,2.6v20.1 C139.5,147,138.4,148.1,137,148.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 97.4,
    y: 47.5,
    className: "st0",
    width: 5.1,
    height: 59
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.8,50.1H34.2c-1.4,0-2.6-1.1-2.6-2.6c0-1.4,1.1-2.6,2.6-2.6h131.6c1.4,0,2.6,1.1,2.6,2.6 C168.3,48.9,167.2,50.1,165.8,50.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51,163.2H34.2c-1.4,0-2.6-1.1-2.6-2.6c0-1.4,1.1-2.6,2.6-2.6H51c1.4,0,2.6,1.1,2.6,2.6 C53.5,162,52.4,163.2,51,163.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.7,163.2H62.9c-1.4,0-2.6-1.1-2.6-2.6c0-1.4,1.1-2.6,2.6-2.6h16.8c1.4,0,2.6,1.1,2.6,2.6 C82.2,162,81.1,163.2,79.7,163.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.4,163.2H91.6c-1.4,0-2.6-1.1-2.6-2.6c0-1.4,1.1-2.6,2.6-2.6h16.8c1.4,0,2.6,1.1,2.6,2.6 C110.9,162,109.8,163.2,108.4,163.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.1,163.2h-16.8c-1.4,0-2.6-1.1-2.6-2.6c0-1.4,1.1-2.6,2.6-2.6h16.8c1.4,0,2.6,1.1,2.6,2.6 C139.6,162,138.5,163.2,137.1,163.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.8,163.2H149c-1.4,0-2.6-1.1-2.6-2.6c0-1.4,1.1-2.6,2.6-2.6h16.8c1.4,0,2.6,1.1,2.6,2.6 C168.3,162,167.2,163.2,165.8,163.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandNuevo);
export default __webpack_public_path__ + "static/media/Sand-NUEVO.54d3ed1f82b989cf73c637cd80393687.svg";
export { ForwardRef as ReactComponent };